var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 10",
    width: 16,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 10,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAMAAACKYC6uAAAAAXNSR0IB2cksfwAAAQ5QTFRFY2NjUVFR4uLi////9vb2+vr68vLy7+/v8PDwwcHBSkpKbm5uPj4+ERERe3t79fX19/f38vLyWFhYDw8PUlJSW1tbAAAAenp6/f39+fn57+/vVFRUdnZ23t7eNTU1AQEBe3t78fHxVlZWBQUFKSkp0NDQ5OTkhISEMDAweXl5/f39/Pz8+Pj48PDwU1NTBAQENTU1NjY2xcXF39/fh4eHfHx8NDQ0eHh48/PzVFRUBgYGNzc3QkJCMjIyg4ODf39/gICANDQ0XFxcNzc3Q0NDPj4+fHx8hISEgoKCNTU1OTk5Q0NDPz8/gYGBhYWFgoKCODg4RUVFQEBAgoKChoaGg4ODNTU1NDQ0RUVFQUFB24vB8AAAAFp0Uk5TKpAcAAAAAAAAOYoVl/iGAAAJrPdwrP+FAgAPq4QQqP+EDar/hAMABqaGAQAACav/gQAAAAAMpogMrP+AAAAAAA2nooICAAAACKaAAAAAAA6CAAAAAAusiwEAxFS74QAAAJNJREFUeJw9ytUSgkAABdDVBbHBuoqt2N3djd3x/z8iMI6vZw4hOj1lGIY1cEaOmswWYrXZKcurwAkOp8tNPIDXJ6og+ANAkITCiESpyBr4WBxSIklS6QyQzeULxRLKlWqN1BvNFtCmnS56/cFQgdF4MlXODL35YqnBar2RAUjb3f4Hh+NJhnS+XP9wuz+er/dHgy+HFxjAHuhsKwAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownDark);
export default __webpack_public_path__ + "static/media/downDark.c2bde0fd4aad86e34c88dc5ea895cc84.svg";
export { ForwardRef as ReactComponent };